import React from 'react';
import { FaMapPin } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import mapimage from '../../assets/map.png'





const ContactForm = () => {
  return (
    <main className="w-full py-12">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header Section */}
        
        <div>
        <h1
          className="lg:text-6xl md:text-3xl text-2xl font-bold text-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          Get in{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#E10B7B] via-[#652D90 ] to-[#1C85C7] animate-bounce">
            Touch
          </span>
        </h1>
        <h2 className="text-center text-white  pt-4">
          Have a project in mind? Fill out the form below and our team will get back to you shortly
        </h2>
      </div>

       
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
        <a href="https://maps.app.goo.gl/MmsBufTg6gqeY1uh8" target="_blank" rel="noopener noreferrer">
          <div className="rounded-2xl overflow-hidden h-64 relative group transition-all duration-300 hover:shadow-lg hover:shadow-pink-500/20">
          <div
              className="absolute inset-0 bg-cover bg-center"
               style={{ backgroundImage: `url(${mapimage})` }}
                ></div>            
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/80 to-gray-900/30"></div>
            
            <div className="absolute inset-0 p-6 flex flex-col justify-between">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center backdrop-blur-sm">
                <FaMapPin className="text-purple-600" size={20} />
              </div>
              
              <div className="text-white">
                <h3 className="text-xl font-bold mb-2">Location</h3>
                <p className="text-gray-300 text-sm">Uttar Dhoka, Lazimpat, Kathmandu</p>
                
              </div>
            </div>
          </div>
          </a>
          
       <a href="mailto:logolab@gmail.com">

          <div className="rounded-2xl h-64 relative group transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20 overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('https://images.pexels.com/photos/5474294/pexels-photo-5474294.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')" }}></div>
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/80 to-gray-900/30"></div>
            
            
            <div className="absolute inset-0 p-6 flex flex-col justify-between">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center backdrop-blur-sm">
                <IoMail className="text-purple-600" size={20} />
              </div>
              
              <div className="text-white">
                <h3 className="text-xl font-bold mb-2">Contact Info</h3>
                <span className='text-gray-300 text-sm'>Email: <span className="text-gray-300 text-sm hover:underline cursor-pointer">logolabnepal@gmail.com</span></span>
                </div>
            </div>
          </div>
          </a>


      <a href="https://api.whatsapp.com/send?phone=9749761111">
          <div className="rounded-2xl h-64 relative group transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20 overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('https://images.pexels.com/photos/821754/pexels-photo-821754.jpeg')" }}></div>
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/80 to-gray-900/30"></div>
            
           
            <div className="absolute inset-0 p-6 flex flex-col justify-between">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center backdrop-blur-sm">
                <FaPhoneAlt className="text-purple-600" size={20} />
              </div>
              
              <div className="text-white">
                <h3 className="text-xl font-bold mb-3">Call Now</h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-2">
                    <span className='text-gray-300 text-sm'>Phone: <span className="text-gray-300 text-sm hover:underline cursor-pointer">+977 9765978888</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </a>


        </div>
      </div>
    </main>
  );
};

export default ContactForm;